var ApiStatus = /*#__PURE__*/function (ApiStatus) {
  ApiStatus[ApiStatus["ERROR"] = 1] = "ERROR";
  ApiStatus[ApiStatus["INVALID_CREDENTIALS"] = 2] = "INVALID_CREDENTIALS";
  ApiStatus[ApiStatus["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  ApiStatus[ApiStatus["WRONG_REGION"] = 3] = "WRONG_REGION";
  return ApiStatus;
}(ApiStatus || {});
export default ApiStatus;